import { defineMessages } from 'react-intl';

export default defineMessages({
    inv1: {
        id: 'quoteandbind.PPLProLinedirectives.templates.InvestmentTable.Investment',
        defaultMessage: "Investment"
    },
    groCom2: {
        id: 'quoteandbind.PPLProLinedirectives.templates.InvestmentTable.Gross Commission',
        defaultMessage: "Gross Commission"
    },
    des3: {
        id: 'quoteandbind.PPLProLinedirectives.templates.InvestmentTable.Description',
        defaultMessage: "Description"
    }
});